export default {
  state: {
    ttests: [],
  },
  mutations: {
    addNewTest(state, data) {
      state.ttests.push(data);
      localStorage.setItem("ttests", JSON.stringify(state.ttests));
    },
    loadTests(state, data) {
      data ? (state.ttests = data) : null;
    },
    updateTest(state, data) {
      let index = state.ttests.findIndex(el => el.id == data.id);
      state.ttests[index] = data;
      localStorage.setItem("ttests", JSON.stringify(state.ttests));
    },
  },
  actions: {
    fetchTests({ commit, getters, dispatch }, limit = 3) {
      let tests = JSON.parse(localStorage.getItem("ttests"));
      commit("loadTests", tests);
    },
    editTest({ commit, getters, dispatch }) {},
  },
  getters: {
    allTests(state) {
      return state.ttests;
    },
    oneTest: state => id => {
      return state.ttests.find(el => el.id === id);
    },
  },
};
